import { useId } from 'react';
import type { ReactNode } from 'react';
import { Flex, Text } from '@backstage/ui';

export function DocsSection({
  title,
  children,
  headingId: headingIdProp,
}: {
  title: string;
  children: ReactNode;
  /** Pass when a child needs the heading id, e.g. for its own aria-labelledby. */
  headingId?: string;
}) {
  const generatedId = useId();
  const headingId = headingIdProp ?? generatedId;

  return (
    <section aria-labelledby={headingId}>
      <Flex direction="column" gap="4">
        <Text as="h2" id={headingId} variant="body-large" weight="bold">
          {title}
        </Text>
        {children}
      </Flex>
    </section>
  );
}
